import { addSeconds, format } from 'date-fns/esm'

import { useAppSelector } from '@user/store/hooks'
import { formatBestFit } from '@user/store/scheduling'
import { selectAllTechs, techDisplayName } from '@user/store/techs'

import { useActions } from './useActions'
import { useGetScheduleLink } from './useGetScheduleLink'
import { useSchedulingWizard } from '../../../wizardContext'
import type { AppointmentSlotProps } from '../AppointmentSlot'

export function useBestFitResult(props: AppointmentSlotProps) {
  const {
    assignee,
    assigneeId,
    alternateTimes,
    milesFromPreviousStop: miles,
    driveSecondsFromPreviousStop: seconds,
  } = props.result

  const { adtlTimesOpen, onClickAdtlTimes, onClickResult } = useActions(props)

  const adtlTimesLabel = `View ${adtlTimesOpen ? 'Less' : 'More'} Times`
  const showAdtlTimesLink = alternateTimes.length > 0

  const [{ bestFitInput, commitProcessing }] = useSchedulingWizard()

  const tech = useAppSelector((state) =>
    selectAllTechs(state).find((t) => t.techId === assigneeId),
  )

  const name = tech ? techDisplayName(tech) : assignee

  const scheduleLink = useGetScheduleLink(assigneeId, bestFitInput.startDate)

  const driveTime = format(
    addSeconds(new Date(0, 0), seconds),
    seconds > 3600 ? 'hh:mm:ss' : 'mm:ss',
  )

  const formatted = formatBestFit(props.result)

  const formattedAltTimes = alternateTimes.map(formatBestFit)

  return {
    ...formatted,
    name,
    driveTime,
    scheduleLink,
    onClickResult,
    adtlTimesOpen,
    adtlTimesLabel,
    onClickAdtlTimes,
    commitProcessing,
    formattedAltTimes,
    showAdtlTimesLink,
    miles: miles.toFixed(2),
  }
}
